export default __webpack_public_path__ + "static/last_year_2-86cbbc3efa2a78d8c3eedf03180f6691.webp";